import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import { Container } from 'react-bootstrap';

const TimelineItem = ({ exp, index }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const spring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(24px)',
    delay: index * 80,
    config: { tension: 200, friction: 28 },
  });

  return (
    <animated.div ref={ref} style={spring} className="tl-item">
      <div className="tl-dot" />
      <div className="tl-card">
        <div className="tl-card-header">
          <img src={exp.companylogo} alt={exp.company} className="tl-logo" />
          <div className="tl-info">
            <h3 className="tl-company">{exp.company}</h3>
            <p className="tl-role">{exp.role}</p>
          </div>
        </div>
        <div className="tl-meta">
          {exp.location && (
            <span className="tl-location">
              <i className="fas fa-map-marker-alt" /> {exp.location}
            </span>
          )}
          <span className="tl-date">{exp.date}</span>
        </div>
      </div>
    </animated.div>
  );
};

const Timeline = ({ heading, experiences }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const headerSpring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(-20px)',
  });

  return (
    <section id="experience" className="timeline-section">
      <Container>
        <animated.div ref={ref} style={headerSpring}>
          <h2 className="display-4 pb-5 text-center">{heading}</h2>
        </animated.div>
        <div className="tl-container">
          {experiences.data.map((exp, index) => (
            <TimelineItem key={index} exp={exp} index={index} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Timeline;
